"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_js_pagination_1 = __importDefault(require("react-js-pagination"));

var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));

var prop_types_1 = __importDefault(require("prop-types"));

require("./SzPagination.scss");

function SzPagination(_a) {
  var totalItemsCount = _a.totalItemsCount,
      activePage = _a.activePage,
      onChange = _a.onChange,
      itemsCountPerPage = _a.itemsCountPerPage,
      pageRangeDisplayed = _a.pageRangeDisplayed;
  return react_1.default.createElement(react_js_pagination_1.default, {
    activePage: activePage,
    itemsCountPerPage: itemsCountPerPage,
    totalItemsCount: totalItemsCount,
    pageRangeDisplayed: pageRangeDisplayed,
    onChange: onChange,
    itemClass: "page-item",
    linkClass: "page-link",
    innerClass: "Sz-pagination pagination",
    hideDisabled: true,
    firstPageText: react_1.default.createElement(SzIcon_1.default, {
      variant: "line",
      icon: "button-next"
    }),
    lastPageText: react_1.default.createElement(SzIcon_1.default, {
      variant: "line",
      icon: "button-previous"
    }),
    prevPageText: react_1.default.createElement(SzIcon_1.default, {
      variant: "bold",
      icon: "navigation-left-circle-1_1"
    }),
    nextPageText: react_1.default.createElement(SzIcon_1.default, {
      variant: "bold",
      icon: "navigation-right-circle-1_1"
    }),
    linkClassFirst: "text-primary",
    linkClassLast: "text-primary",
    linkClassPrev: "text-primary",
    linkClassNext: "text-primary"
  });
}

exports.default = SzPagination;
SzPagination.propTypes = {
  /**
   * Range of pages in paginator, exclude navigation blocks (prev, next, first, last pages)
   */
  pageRangeDisplayed: prop_types_1.default.number.isRequired,

  /**
   * Required. Total count of items which you are going to display
   */
  totalItemsCount: prop_types_1.default.number.isRequired,

  /**
   * Count of items per page
   */
  itemsCountPerPage: prop_types_1.default.number.isRequired,

  /**
   * Required. Active page
   */
  activePage: prop_types_1.default.number.isRequired,

  /**
   * Required. Page change handler. Receive pageNumber as arg
   */
  onChange: prop_types_1.default.func.isRequired
};